"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductMedia = exports.populateMediaCollection = void 0;
const common_components_1 = require("@as-react/common-components");
const react_redux_1 = require("react-redux");
const ProductSelector_1 = require("../../../redux/product/selectors/ProductSelector");
const ProductDetailV2Container_1 = require("../../../containers/product/ProductDetailV2Container");
const ImageUtil_1 = require("../../../util/ImageUtil");
const common_utils_1 = require("@as-react/common-utils");
const populateMediaCollection = (images, productCode, productImages, videos) => {
    let imageCollection = [];
    let videoCollection = [];
    let mediaCollection = [];
    if (images) {
        imageCollection = images.map((image) => ({
            image,
            sourceSet: (0, ImageUtil_1.getImageSourceSetByProductCode)(productCode, image.picture, productImages),
            video: null,
            isVideo: false,
        }));
        mediaCollection = [...imageCollection];
    }
    if (videos && imageCollection.length > 0) {
        videoCollection = videos
            .filter(video => { var _a; return (_a = video.productVideoDetail) === null || _a === void 0 ? void 0 : _a.url; })
            .map(video => ({
            image: imageCollection[0].image,
            sourceSet: imageCollection[0].sourceSet,
            video,
            isVideo: true,
        }));
        mediaCollection.splice(2, 0, ...videoCollection);
    }
    return mediaCollection;
};
exports.populateMediaCollection = populateMediaCollection;
const useProductMedia = () => {
    const { productImageConfig, feature_toggles: { product_gender_icon: showGenderIcon, product_online_exclusive, product_new_label }, } = (0, common_components_1.useAemConfig)();
    const { productCode } = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetProductDefaults)());
    const alt = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetProductImageAlt)());
    const dynamicSavingsInformation = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetDynamicSavingsInformation)());
    const showSustainabilityLabel = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetProductOurPlanet)());
    const newProduct = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetNewProduct)());
    const { genderFeatureId } = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetProductDefaults)());
    const { images, priceOverlay, webOnly } = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetPreviewInformation)());
    const { productVideos: videos } = (0, ProductDetailV2Container_1.useProductDetailContext)();
    const priceInformation = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetPriceInformation)());
    const savingsPercentage = (0, common_utils_1.showPriceDiscount)(priceInformation.prices, true)
        ? dynamicSavingsInformation === null || dynamicSavingsInformation === void 0 ? void 0 : dynamicSavingsInformation.productDiscountPercentage
        : undefined;
    const showOnlineExclusiveLabel = product_online_exclusive && webOnly;
    const showNewProductLabel = product_new_label && newProduct;
    const mediaCollection = (0, exports.populateMediaCollection)(images, productCode, productImageConfig, videos || []);
    return {
        mediaCollection,
        alt,
        labelsConfig: {
            showGenderIcon,
            genderFeatureId,
            savingsPercentage,
            priceOverlay,
            showNewProductLabel,
            showOnlineExclusiveLabel,
            showSustainabilityLabel,
        },
    };
};
exports.useProductMedia = useProductMedia;
